module.exports = __webpack_public_path__ + "static/23-b08cfdd3db7d9a7e334740a5a4322e88.jpg";